/**
 * LOT 402 — Garde de feature flag pour les pages publiques SPV.
 *
 * Si `REACT_APP_PUBLIC_SPV_OFFER_ENABLED=true` → enfant rendu normalement.
 * Si flag false (défaut) → rendu de la page neutre `PublicSpvDisabledPage`.
 *
 * Cette garde NE TOUCHE PAS aux routes admin/investor/sponsor (privées).
 *
 * LOT 537 v63.2ter — `PublicSpvDisabledPage` est désormais lazy-chargé pour
 * sortir ~6.9 KB du main bundle public. Le Suspense parent global (RouteFallback)
 * couvre les rares premiers ms de chargement.
 */
import { lazy } from 'react';
import { isPublicSpvOfferEnabled } from '../config/featureFlags';

const PublicSpvDisabledPage = lazy(() => import('../pages/public/PublicSpvDisabledPage'));

export default function PublicSpvGate({ children }) {
  if (isPublicSpvOfferEnabled()) {
    return children;
  }
  return <PublicSpvDisabledPage />;
}
